'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus from "./presto.-Site-Tables$-Group-Status.js";
var $p;
/** @constructor */
function $c_Lpresto_SiteTables$GroupStatus$$anon$22() {
  this.K0 = null;
  this.D6 = null;
  $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus.$ct_Lpresto_SiteTables$GroupStatus__T__T__(this, "Algumas configuradas para o grupo", "Algumas credenciais configuradas para o grupo");
}
export { $c_Lpresto_SiteTables$GroupStatus$$anon$22 as $c_Lpresto_SiteTables$GroupStatus$$anon$22 };
$p = $c_Lpresto_SiteTables$GroupStatus$$anon$22.prototype = new $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus.$h_Lpresto_SiteTables$GroupStatus();
$p.constructor = $c_Lpresto_SiteTables$GroupStatus$$anon$22;
/** @constructor */
function $h_Lpresto_SiteTables$GroupStatus$$anon$22() {
}
export { $h_Lpresto_SiteTables$GroupStatus$$anon$22 as $h_Lpresto_SiteTables$GroupStatus$$anon$22 };
$h_Lpresto_SiteTables$GroupStatus$$anon$22.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return "Partial";
});
$p.l = (function() {
  return "Partial";
});
var $d_Lpresto_SiteTables$GroupStatus$$anon$22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SiteTables$GroupStatus$$anon$22, "presto.SiteTables$GroupStatus$$anon$22", ({
  Rn: 1,
  d7: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_SiteTables$GroupStatus$$anon$22 as $d_Lpresto_SiteTables$GroupStatus$$anon$22 };
//# sourceMappingURL=presto.-Site-Tables$-Group-Status$$anon$22.js.map
